import type { AdminDashboardData } from '@workspace/api-backend'
import { DashboardCard, DashboardSection } from './dashboard-card'
import { FunnelList } from './funnel-list'

export function OnboardingSection({ data }: { data: AdminDashboardData }) {
  const founderDropped =
    (data.funnels.founder[0]?.count ?? 0) - (data.funnels.founder[2]?.count ?? 0)
  return (
    <DashboardSection title="Onboarding funnels">
      <div className="grid gap-4 lg:grid-cols-2">
        <DashboardCard
          title="Founder funnel"
          subtitle={`${founderDropped.toLocaleString()} dropped before creating a startup`}
        >
          <FunnelList stages={data.funnels.founder} />
        </DashboardCard>
        <DashboardCard title="Investor funnel" subtitle="New investor signups">
          <FunnelList stages={data.funnels.investor} />
        </DashboardCard>
      </div>
    </DashboardSection>
  )
}
